import { connect } from 'react-redux';
import ColorPicker from '../components/ColorPicker';
import { setColor } from '../actions/actionCreators/colorPicker';

function findPreviousColor(state) {
    const activePart = state.configurator.activePart;

    // user is currently editing parts (individual)
    if (activePart) {
        return state.configurator.config.parts[activePart].color;
    }

    // user is currently adding a customText
    if (state.configurator.customizationType === 'text') {
        return state.textEditor.color;
    }

    // default
    return { r: 255, g: 255, b: 255 };
}

function mapStateToProps(state) {
    return {
        color: state.colorPicker.color,
        customColors: state.configurator.customColors,
        previousColor: findPreviousColor(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onChangeComplete: color => dispatch(setColor(color.rgb)),
    };
}

const ColorPickerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ColorPicker);

export default ColorPickerContainer;
